/* Warehouse Bold — a real body scroll lock for the CART drawer on iOS.
 *
 * the base theme locks the page with `body { overflow: hidden }` (theme.css, applied
 * through the `modal-show` / `modal-showing` classes). iOS Safari ignores that
 * for touch: pans fall straight through and scroll the document behind the
 * open drawer, which is what Owen filmed (2026-08-09) — the product page
 * sliding around underneath an open cart.
 *
 * The mobile menu already solved this with a position:fixed body lock
 * (assets/wb-mobile-menu.js). This is the same technique, applied to the cart
 * drawer, which the menu's own copy could not reach: the menu bypasses
 * DrawerComponent entirely, while the cart drawer is driven by it.
 *
 * ⚠ Order and restoration are both load-bearing, exactly as documented there:
 *   · capture scrollY BEFORE going fixed — the lock collapses the scroll range
 *     and clamps scrollY to 0, so reading it afterwards gives 0 and the page
 *     jumps to the top on close;
 *   · restore with scroll-behavior forced to auto — <html> carries
 *     scroll-behavior: smooth, and a glide back to the pre-lock position reads
 *     as the page scrolling itself.
 *
 * Phones only. On desktop the theme's overflow:hidden works, and a fixed body
 * there would fight the scrollbar-width compensation the base theme already applies.
 */
(() => {
  if (window.__wbCartLock) return;
  window.__wbCartLock = true;

  const MOBILE = () => window.innerWidth < 750;
  let locked = false;
  let lockedY = 0;

  const lock = () => {
    if (locked || !MOBILE()) return;
    locked = true;
    lockedY = window.scrollY || document.documentElement.scrollTop || 0;
    const b = document.body.style;
    b.position = 'fixed';
    b.top = -lockedY + 'px';
    b.left = '0';
    b.width = '100%';
  };

  const unlock = () => {
    if (!locked) return;
    locked = false;
    const b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.width = '';
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedY);
    document.documentElement.style.scrollBehavior = prev;
  };

  /* The drawer is a custom element whose open state lives in an attribute, so
     an attribute observer is the one signal that cannot drift out of step with
     it — no matter which of the theme's several code paths did the opening
     (trigger click, cart:refresh with open:true, add-to-cart, or the editor). */
  const watch = (el) => {
    if (!el || el.__wbLockWatched) return;
    el.__wbLockWatched = true;
    const sync = () => (el.hasAttribute('open') ? lock() : unlock());
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['open'] });
    sync();
  };

  const init = () => {
    watch(document.querySelector('cart-drawer'));
    /* The section can be re-rendered by the theme editor, which replaces the
       element rather than mutating it. */
    document.addEventListener('shopify:section:load', () => watch(document.querySelector('cart-drawer')));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
